import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { duration: { type: Number, default: 5000 } }

  connect() {
    requestAnimationFrame(() => this.element.classList.add("toast--visible"))
    this.timer = setTimeout(() => this.dismiss(), this.durationValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  dismiss() {
    clearTimeout(this.timer)
    this.element.classList.remove("toast--visible")
    this.element.classList.add("toast--leaving")
    this.element.addEventListener("transitionend", () => this.element.remove(), { once: true })
  }
}
